/**
 * Utility để tạo lời chào và thông điệp động theo thời gian thực
 */

/**
 * Lấy buổi trong ngày
 * @returns {string} 'morning' | 'noon' | 'afternoon' | 'evening'
 */
export const getTimeOfDay = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 11) return 'morning';
  if (hour >= 11 && hour < 14) return 'noon';
  if (hour >= 14 && hour < 18) return 'afternoon';
  return 'evening';
};

/**
 * Lấy lời chào theo buổi
 * @param {string} name - Tên nhân viên
 * @returns {string}
 */
export const getGreeting = (name) => {
  const timeOfDay = getTimeOfDay();
  switch (timeOfDay) {
    case 'morning':
      return `Chào buổi sáng rạng rỡ, ${name} ☀️`;
    case 'noon':
      return `Chào buổi trưa, ${name} 🌤️`;
    case 'afternoon':
      return `Chào buổi chiều, ${name} 🌥️`;
    case 'evening':
      return `Chào buổi tối, ${name} 🌙`;
    default:
      return `Xin chào, ${name} 👋`;
  }
};

/**
 * Lấy thông điệp truyền cảm hứng cho lời chào
 * @returns {string}
 */
export const getInspirationalQuote = () => {
  const timeOfDay = getTimeOfDay();
  const quotes = {
    morning: [
      "Chúc bạn một ngày làm việc tràn đầy năng lượng và hiệu quả. 🚀",
      "Ngày mới khởi đầu với những cơ hội mới. Cố gắng nhé! ✨",
      "Hãy cùng tạo nên những giá trị tuyệt vời trong ngày hôm nay. 💪",
      "Năng lượng buổi sáng quyết định thành công cả ngày. Let's go! 🌟"
    ],
    noon: [
      "Đừng quên nghỉ ngơi và nạp năng lượng cho buổi chiều nhé. 🍱",
      "Chúc bạn có một bữa trưa ngon miệng và thoải mái. ☕",
      "Nghỉ ngơi một chút để tỉnh táo hơn cho công việc tiếp theo. 🔋",
      "Tái tạo năng lượng để bứt phá vào buổi chiều nào! 🌈"
    ],
    afternoon: [
      "Sắp hoàn thành mục tiêu ngày hôm nay rồi, cố lên nào! 🎯",
      "Chúc bạn có một buổi chiều làm việc tập trung và bứt phá. 🔥",
      "Kiên trì thêm một chút, thành công đang chờ đón bạn. 🏆",
      "Hoàn thành nốt những việc quan trọng để về sớm thôi! 🏃‍♂️"
    ],
    evening: [
      "Chúc bạn có thời gian nghỉ ngơi ấm áp bên gia đình. 🏠",
      "Vất vả rồi! Hãy thư giãn và tận hưởng buổi tối trọn vẹn nhé. 🛀",
      "Chúc bạn một buổi tối bình yên và ngủ ngon. 💤",
      "Khép lại một ngày tuyệt vời và sẵn sàng cho ngày mai nhé. ✨"
    ]
  };
  
  const selectedQuotes = quotes[timeOfDay] || quotes.morning;
  return selectedQuotes[Math.floor(Math.random() * selectedQuotes.length)];
};

/**
 * Lấy thông báo chấm công thành công động
 * @param {string} type - 'checkin' | 'checkout'
 * @returns {string}
 */
export const getSuccessMessage = (type) => {
  const checkinMessages = [
    "✅ Tuyệt vời! Bạn đã bắt đầu ngày mới đúng lúc. Chúc bạn một ngày làm việc thật vui vẻ!",
    "🚀 Đã chấm công vào. Hãy cùng tạo nên một ngày làm việc ý nghĩa nhé!",
    "✨ Chấm công thành công! Năng lượng của bạn hôm nay sẽ tạo nên những điều kỳ diệu.",
    "👍 Rất tốt! Hệ thống đã ghi nhận thời gian vào. Chúc bạn một ngày suôn sẻ.",
    "🌞 Chào ngày mới! Chúc bạn làm việc hăng say, kết quả cầm tay.",
    "📈 Bắt đầu ngày mới thật năng suất nào. Chấm công thành công!"
  ];
  
  const checkoutMessages = [
    "🚪 Vất vả rồi! Bạn đã hoàn thành công việc hôm nay. Về nhà nghỉ ngơi thư giãn thôi nào.",
    "🌟 Chấm công ra thành công. Chúc bạn có một buổi tối thật trọn vẹn và hạnh phúc.",
    "🏁 Đã ghi nhận thời gian ra. Hãy gác lại công việc và tận hưởng thời gian nghỉ ngơi nhé.",
    "🍵 Chúc mừng bạn đã hoàn thành một ngày làm việc tuyệt vời. Hẹn gặp lại bạn vào ngày mai!",
    "🌈 Tan làm thôi! Hãy tận hưởng những giây phút thoải mái nhất nhé.",
    "👏 Một ngày làm việc hiệu quả đã kết thúc. Chúc bạn ngủ ngon!"
  ];
  
  const messages = type === 'checkin' ? checkinMessages : checkoutMessages;
  return messages[Math.floor(Math.random() * messages.length)];
};
